import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import Pagination from '@/components/ui/pagination/Pagination';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import BookCardsList from '@/components/ui/book-cards-list/BookCardsList';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { getCurrentYear } from '@/helpers/helpers';
import { IBookPage } from '@/interfaces/booksPage.interface';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';

export interface INewProps {
  books: IBookPage;
}

const New: FC<INewProps> = ({ books }) => {
  const pagesCount = Math.ceil(books?.total_count / BOOKS_FOR_PAGE);

  const currentPage = books.page;
  const currentYear = getCurrentYear();

  //Seo block
  const SEO_TITLE = `Новинки книг фентези и фантастики ${currentYear} — скачать бесплатно или читать онлайн в электронной библиотеке Fantasy Worlds${currentPage > 1 ? `. Cтраница ${currentPage}.` : ``}`;
  const SEO_DESCRIPTION = `Новинки книг 🕮 фентези и фантастики ${currentYear}. ▶ Вы можете скачать бесплатно самые новые книги 📚 в жанре фентези или фантастики в электронной библиотеке Fantasy Worlds.${
    currentPage > 1 ? ` Cтраница ${currentPage}.` : ``
  }`;
  const SEO_CANONICAL = '/new';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()}>
      <Breadcrumbs firstPageName="Новинки" />
      <Pagination pagesCount={pagesCount ?? 0} postName={`new/`} />
      <SectionTitle name="Новинки" />
      <BookCardsList books={books.data} />
      <Pagination pagesCount={pagesCount ?? 0} postName={`new/`} />
    </Layout>
  );
};

export default New;
